import { PortalModalsActionTypes } from './portalModals.types';

export const initialState = {
  loading: false,
  modals: [],
  error: false,
};

const portalModalsReducer = (state = initialState, action) => {
  switch (action.type) {
    case PortalModalsActionTypes.PORTAL_MODALS_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case PortalModalsActionTypes.PORTAL_MODALS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        modals: action.payload?.modals ?? [],
      };
    case PortalModalsActionTypes.PORTAL_MODALS_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        modals: [],
      };
    case PortalModalsActionTypes.PORTAL_MODALS_CLEAR:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default portalModalsReducer;
